import React from "react";

/** Paleta con fondo suave + borde y texto tintados */
const palette = {
  emerald: { bg: "bg-emerald-50", text: "text-emerald-900", border: "border-emerald-200", dot: "bg-emerald-500" },
  amber:   { bg: "bg-amber-50",   text: "text-amber-900",   border: "border-amber-200",   dot: "bg-amber-500" },
  sky:     { bg: "bg-sky-50",     text: "text-sky-900",     border: "border-sky-200",     dot: "bg-sky-500" },
  fuchsia: { bg: "bg-fuchsia-50", text: "text-fuchsia-900", border: "border-fuchsia-200", dot: "bg-fuchsia-500" },
  slate:   { bg: "bg-slate-50",   text: "text-slate-900",   border: "border-slate-200",   dot: "bg-slate-500" },
  violet:  { bg: "bg-violet-50",  text: "text-violet-900",  border: "border-violet-200",  dot: "bg-violet-500" },
  rose:    { bg: "bg-rose-50",    text: "text-rose-900",    border: "border-rose-200",    dot: "bg-rose-500" },
  teal:    { bg: "bg-teal-50",    text: "text-teal-900",    border: "border-teal-200",    dot: "bg-teal-500" },
  indigo:  { bg: "bg-indigo-50",  text: "text-indigo-900",  border: "border-indigo-200",  dot: "bg-indigo-500" },
  lime:    { bg: "bg-lime-50",    text: "text-lime-900",    border: "border-lime-200",    dot: "bg-lime-500" },
};

const paletteKeys = Object.keys(palette);

/** Mapeo explícito de etiquetas conocidas → tono fijo */
const toneByLabel = (label = "") => {
  switch (label) {
    case "Connexions": return "amber";
    case "Raonament i prova": return "sky";
    case "Comunicació i representació": return "fuchsia";
    case "Mesura":
    case "Processos": return "slate";
    default: return null; // deja que el hash/seed decida
  }
};

/** Hash simple y estable (djb2-xor) */
const hash = (str = "") => {
  let h = 5381;
  for (let i = 0; i < str.length; i++) h = ((h << 5) + h) ^ str.charCodeAt(i);
  return Math.abs(h);
};

/**
 * TagPill
 * Props:
 * - label (string)     -> texto a mostrar
 * - tone  (string?)    -> fuerza un tono (opcional)
 * - seed  (string?)    -> "session" | "project" | etc. para variar entre contextos
 * - index (number?)    -> para ciclar colores dentro de un mismo grupo
 */
export default function TagPill({ label, tone, seed = "", index = 0 }) {
  // 1) Si se fuerza tone, úsalo
  let chosen = tone;

  // 2) Si hay mapeo explícito para esta etiqueta, úsalo
  if (!chosen) chosen = toneByLabel(label);

  // 3) Si no, elige uno estable según label+seed (+index para variedad intra-grupo)
  if (!chosen) {
    const i = (hash(`${label}|${seed}`) + (index || 0)) % paletteKeys.length;
    chosen = paletteKeys[i];
  }

  const c = palette[chosen] || palette.emerald;

  return (
    <span className={`inline-flex items-center gap-2 text-xs sm:text-sm px-3 py-1 rounded-full border ${c.bg} ${c.border} ${c.text} leading-none`}>
      <span className={`w-2.5 h-2.5 rounded-full ${c.dot}`} />
      <span className="whitespace-normal">{label}</span>
    </span>
  );
}
